import { render, staticRenderFns } from "./GrupoLaidom.vue?vue&type=template&id=8ce5cd94&scoped=true"
import script from "./GrupoLaidom.vue?vue&type=script&lang=js"
export * from "./GrupoLaidom.vue?vue&type=script&lang=js"
import style0 from "./GrupoLaidom.vue?vue&type=style&index=0&id=8ce5cd94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce5cd94",
  null
  
)

export default component.exports